import { CMDLottery } from "./CMDLottery"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScLotterySetting implements ICommand
{

	public HostID : number = 0;
	public CurrentGame : CMDLottery;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.CurrentGame = new CMDLottery();
		this.CurrentGame.fromBytes(ba);
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		let tempBuf1 = this.CurrentGame.toBytes().toBuffer();
		ba.appendBuf(tempBuf1)

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScLotterySetting();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'CurrentGame(CMDLottery)='+this.CurrentGame+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30025;
	}

	public getCmdName() : string
	{
		return 'ScLotterySetting';
	}

}
